const doc = [({"da":({"js":({"nemoa":({"activities":({"show":({"index":({"overview":"Oversigt"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;